<template>
    <div class="empty-table">
      <template v-if="errorType === 'notFoundProduct'">
        <img src="@/assets/images/empty-search.png" alt="Ürün bulunamadı" />
        <span class="title">
          {{ didNotFind ? DID_NOT_FIND_MESSAGE : SEARCH_CONDITION_FAILED_MESSAGE }}
        </span>
        <span class="description">
          {{ didNotFind ? DID_NOT_FIND_DESCRIPTON : SEARCH_CONDITION_FAILED_DESCRIPTON }}
        </span>
        <AppButton v-if="didNotFind" secondary lg @click="goToAddNewProduct" title="Ürün Ekle" />
      </template>
  
      <template v-if="errorType === 'anErrorOccurred'">
        <img src="@/assets/images/empty-search.png" alt="Hata oluştu" />
        <span class="title">
          <!-- Burada api response ayni tipde donmedigi icin hata mesaji duzgun sekilde alinamiyor o yuzden statik olarak verdik hata mesajinin daha sonra guncellenmesi gerekebilir. -->
          {{ ERROR_MESSAGE }}
        </span>
      </template>
    </div>
  </template>
  
  <script setup>
  import { AppButton } from "@n11/so-ui-components";
  
  import {
    ERROR_MESSAGE,
    DID_NOT_FIND_MESSAGE,
    SEARCH_CONDITION_FAILED_MESSAGE,
    DID_NOT_FIND_DESCRIPTON,
    SEARCH_CONDITION_FAILED_DESCRIPTON,
  } from "@/utils/enum/resultMessages";
  
  const props = defineProps({
    didNotFind: {
      type: Boolean,
      required: true,
    },
    errorType: {
      type: String,
      required: false,
      default: 'notFoundProduct',
    }
  });
  
  const goToAddNewProduct = () => window.open("/selleroffice/v2/product/create/single", "_blank");
  </script>
  
  <style lang="scss" scoped>
  @import "@/assets/styles/variables.scss";
  @import "@/assets/styles/utilities.scss";
  
  .empty-table {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: sticky;
    left: 0;
    margin-top: 32px;
    width: 100%;
  
    img {
      max-width: 185px;
      margin-bottom: 24px;
    }
  
    > span {
      display: block;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: -0.05px;
      color: $colorN80;
  
      &:first-of-type {
        margin-bottom: 12px;
        font-size: 20px;
        font-weight: 600;
        line-height: 26px;
        letter-spacing: -0.2px;
      }
  
      &:last-of-type {
        font-weight: 600;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.05px;
      }
    }
  
    button {
      width: 126px;
      gap: 4px;
  
      img {
        margin: auto 0;
      }
    }
  }

.product-not-found {
  width: 100%;
}
  </style>
  